import React, { useState } from "react";
import submit from "submit-form";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../parts/modal-new";

export const SaveMealPlanAsTemplateModal = ({ locals }) => {
  const { t } = useTranslation(["athlete-portal", "common"]);
  const { query } = locals;
  const { mealPlan: mealPlanId } = query;

  const initialState = {
    title: "",
    description: "",
  };
  const [state, setState] = useState(initialState);

  const { title, description } = state;

  /**
   * Update the state
   * @param {*} newState
   * @returns
   */
  const updateState = (newState) =>
    setState((prevState) => ({ ...prevState, ...newState }));

  /**
   * Create a template with the same meal plan information
   */
  const handleSubmit = () => {
    const body = {
      mealPlanId,
      title: String(title),
      description: String(description),
    };
    submit(`/actions/meal-planner/create-template`, {
      method: "POST",
      body,
    });
  };

  /**
   * Get the input values
   * @param {*} e
   */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    updateState({ [name]: value });
  };

  return (
    <Modal
      className="save-meal-plan-as-template"
      title={t("athlete-portal:saveMealPlanAsTemplateModal.title")}
    >
      <div className="body">
        <div className="inputs">
          <div>
            <label className="label" htmlFor="title">
              {t("athlete-portal:saveMealPlanAsTemplateModal.templateTitle")}
            </label>
            <input
              type="text"
              placeholder={t(
                "athlete-portal:saveMealPlanAsTemplateModal.templateTitlePlaceholder"
              )}
              name="title"
              value={title}
              onChange={handleInputChange}
              maxLength={60}
            />
          </div>
          <div>
            <label className="label" htmlFor="description">
              {t("athlete-portal:saveMealPlanAsTemplateModal.templateDescription")}
            </label>
            <textarea
              name="description"
              className="textarea-input"
              placeholder={t(
                "athlete-portal:saveMealPlanAsTemplateModal.templateDescriptionPlaceholder"
              )}
              value={description}
              onChange={handleInputChange}
              maxLength={100}
            />
          </div>
        </div>

        <div className="buttons justify-end">
          <button
            data-button-type="primary"
            onClick={handleSubmit}
            disabled={title.length === 0 || description.length === 0}
          >
            {t("common:save")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

SaveMealPlanAsTemplateModal.propTypes = {
  locals: PropTypes.object,
};
